import { TranslationKey } from './en';

export const no: Record<TranslationKey, string> = {
  'common.cancel': 'Avbryt',
  'common.close': 'Lukk',
  'common.copy': 'Kopier',
  'common.copied': 'Kopiert!',
  'common.logout': 'Logg ut',
  'common.logoutTooltip': 'Logg ut',
  'common.refreshTooltip': 'Oppdater',
  'common.backToOverview': 'Tilbake til oversikten',
  'common.noDescription': 'Ingen beskrivelse',
  'common.retry': 'Prøv igjen',
  'common.yes': 'Ja',
  'common.no': 'Nei',
  'common.saveButton': 'Lagre',
  'common.savingButton': 'Lagrer...',
  'common.total': 'Totalt',
  'common.col.date': 'Dato',
  'common.col.status': 'Status',

  'errors.genericError': 'Noe gikk galt.',
  'errors.defaultError': 'Det oppstod en feil',
  'errors.tryAgain': 'Noe gikk galt. Prøv igjen.',
  'errors.signupFailed': 'Organisasjonen din kunne ikke settes opp. Logg inn på nytt og prøv igjen; kontakt support hvis dette vedvarer.',
  'errors.joinFailed': 'Forespørselen din kunne ikke sendes. Logg inn på nytt og prøv igjen.',
  'errors.requestFailed': 'Noe gikk galt under innsendingen.',
  'errors.api.badRequest': 'Ugyldig forespørsel. Sjekk de angitte dataene.',
  'errors.api.unauthorized': 'Økten din har utløpt. Logg inn igjen.',
  'errors.api.forbidden': 'Du har ikke tilgang til denne funksjonen.',
  'errors.api.notFound': 'Det forespurte elementet ble ikke funnet.',
  'errors.api.conflict': 'Denne handlingen kan ikke utføres på grunn av en konflikt.',
  'errors.api.tooMany': 'For mange forespørsler. Prøv igjen senere.',
  'errors.api.serverError': 'Det oppstod en serverfeil. Prøv igjen senere.',
  'errors.api.seatLimitReached': 'Sete-grensen er nådd for gjeldende plan.',
  'errors.api.onlyPendingCancel': 'Bare ventende forespørsler kan avbrytes.',
  'errors.api.timeout': 'Forespørselen tok for lang tid. Sjekk internettforbindelsen din og prøv igjen.',

  'nav.servers': 'Servere',
  'nav.workflows': 'Arbeidsflyter',
  'nav.myRequests': 'Mine forespørsler',
  'nav.users': 'Brukere',
  'nav.usage': 'Forbruk',
  'nav.help': 'Hjelp',

  'help.page.title': 'Kom i gang med Chat og MCP',
  'help.page.subtitle': 'Lær hvordan du bruker AI-chat og kobler til MCP-servere.',
  'help.whatIsChat.title': 'Hva er Chat?',
  'help.whatIsChat.body':
    'Chat er en selvhostet AI-assistent basert på åpne modeller. Dataene dine forblir på plattformen — ingenting deles med eksterne parter. Alle samtaler er private og kun synlige for deg.',
  'help.startChat.title': 'Hvordan åpner jeg chatten?',
  'help.startChat.body':
    'Klikk på "Chat"-knappen øverst på Servere-siden. Du blir automatisk logget inn med samme konto som portalen.',
  'help.addMcpPortal.title': 'Trinn 1: Installer en MCP i chat',
  'help.addMcpPortal.body':
    'Gå til detaljsiden for MCP-en du vil bruke (klikk på MCP-kortet). Klikk på "Installer i chat"-knappen ved siden av statusbrikken. Knappen endres til "Installert" når det er ferdig. Dette registrerer MCP-en som en verktøyserver i chatmiljøet ditt.',
  'help.connectMcp.title': 'Trinn 2: Koble MCP-en i chat',
  'help.connectMcp.body':
    'Åpne Chat og klikk på profilbildet ditt (nederst til venstre). Gå til Innstillinger > Integrations. Under "Manage Tool Servers", klikk på +-knappen. Sett typen til "MCP Streamable HTTP". Kopier MCP-URL-en fra Connect-fanen på serverdetaljsiden. La Auth stå på "None" og klikk Save. MCP-verktøyene er nå tilgjengelige i samtalene dine.',
  'help.functionCalling.title': 'Trinn 3: Aktiver Function Calling',
  'help.functionCalling.body':
    'Start en ny samtale. Klikk på "Controls" (øverst til høyre, glidebryterikon). Under "Advanced Params", endre "Function Calling" fra "Default" til "Native". Dette sørger for at AI-en faktisk bruker verktøyene.',
  'help.testMcp.title': 'Trinn 4: Test MCP-en',
  'help.testMcp.body':
    'Klikk på koblingsikonet i meldingsfeltet (fire-blokker-ikonet) og slå på MCP-verktøyene. Skriv deretter en melding som "Søk etter kontakter med navnet Jan". AI-en kaller MCP-verktøyet og viser ekte resultater fra systemet ditt. Bruk en modell som støtter verktøykalling (f.eks. Claude Sonnet).',
  'help.createProject.title': 'Bruke prosjektinstruksjoner',
  'help.createProject.body':
    'Noen MCP-servere har prosjektinstruksjoner (CLAUDE.md / GEMINI.md). Kopier disse til AI-prosjektkonfigurasjonen din for å gi AI-en kontekst om hvordan verktøyene skal brukes effektivt.',

  'login.title': 'Smarte utvidelser',
  'login.defaultSubtitle': 'Nyttige verktøy for din favoritt AI-chatclient.',
  'login.loginButton': 'Logg inn',
  'login.email': 'E-postadresse',
  'login.emailPlaceholder': 'mail@domene.no',
  'login.continue': 'Fortsett',
  'login.selectOrganization': 'Velg organisasjonen din',
  'login.noOrganization': 'Ingen organisasjon funnet for dette e-postdomenet.',
  'login.back': 'Tilbake',
  'login.loading': 'Søker etter organisasjoner...',
  'login.sessionExpired': 'Økten din er utløpt. Logg inn på nytt.',
  'login.signInTitle': 'Logg inn',
  'login.signInSubtitle': 'Du blir sendt til din organisasjons påloggingsskjerm.',
  'login.signIn': 'Fortsett til innlogging',
  'signupProgress.title.creating': 'Setter opp {org}',
  'signupProgress.title.signingIn': 'Logger deg inn',
  'signupProgress.subtitle': 'Vi klargjør arbeidsområdet ditt og oppdaterer økten. Dette tar bare et øyeblikk.',
  'signupProgress.orgFallback': 'arbeidsområdet ditt',
  'signupProgress.step.accountConnected': 'Konto tilkoblet',
  'signupProgress.step.creatingOrg': 'Oppretter organisasjonen',
  'signupProgress.step.signingIn': 'Logger deg inn',
  'signupProgress.footer': 'Ikke lukk denne fanen — vi sender deg videre automatisk.',
  'login.joinTitle': 'Be om tilgang til {org}',
  'login.joinSubtitle': 'Det finnes allerede en organisasjon for dette e-postdomenet. Logg inn med arbeidskontoen din for å be om tilgang — en administrator vurderer forespørselen.',
  'login.joinWithGoogle': 'Be om tilgang med Google',
  'login.joinWithMicrosoft': 'Be om tilgang med Microsoft',
  'memberPending.title.pending': 'Venter på godkjenning',
  'memberPending.body.pending': 'Forespørselen din om å bli medlem av {org} venter på godkjenning av en administrator. Du får tilgang så snart det er godkjent.',
  'memberPending.title.rejected': 'Forespørsel avslått',
  'memberPending.body.rejected': 'Forespørselen din om å bli medlem av {org} ble avslått. Kontakt administratoren hvis du tror dette er en feil.',
  'memberPending.logout': 'Logg ut',
  'pendingMembers.section.title': 'Ventende medlemsforespørsler',
  'pendingMembers.section.empty': 'Ingen ventende forespørsler.',
  'pendingMembers.approve': 'Godkjenn',
  'pendingMembers.reject': 'Avslå',
  'pendingMembers.source.kcAuto': 'Automatisk via SSO',
  'login.notValid': 'E-postadressen er ikke gyldig',
  'login.registerTitle': 'Registrer organisasjonen din',
  'login.registerSubtitle': 'Det finnes ingen organisasjon for denne e-postadressen ennå. Gi organisasjonen et navn og fortsett med arbeidskontoen din.',
  'login.organizationName': 'Navn på organisasjonen',
  'login.organizationNamePlaceholder': 'f.eks. Acme AS',
  'login.continueWith': 'Fortsett med',
  'login.or': 'eller',
  'login.signInGoogle': 'Logg inn med Google',
  'login.signInMicrosoft': 'Logg inn med Microsoft',
  'login.signUpGoogle': 'Registrer med Google',
  'login.signUpMicrosoft': 'Registrer med Microsoft',
  'login.signUpEmail': 'Registrer med e-post',
  'login.registering': 'Organisasjonen din opprettes…',
  'login.registeredMessage': 'Organisasjonen er opprettet. Logg inn på nytt for å aktivere administratorrollen din.',
  'login.signInAgain': 'Logg inn på nytt',
  'login.signupFailed': 'Registreringen mislyktes. Prøv igjen.',
  'login.idpUnavailable': 'Identitetsleverandøren er midlertidig utilgjengelig. Prøv igjen.',
  'login.serverUnreachable': 'Kunne ikke nå serveren. Sjekk tilkoblingen og prøv igjen.',

  'servers.page.title': 'MCP-servere',
  'servers.page.subtitle': 'Oppdag tilgjengelige MCP-servere og be om tilgang.',
  'servers.chat.button': 'Chat',
  'servers.chat.notConfiguredTooltip': 'Chat er ikke konfigurert.',
  'servers.empty.adminTitle': 'Ingen MCP-servere funnet',
  'servers.empty.userTitle': 'Ingen tilgang til MCP-er',
  'servers.empty.adminSubtitle': 'Det er for øyeblikket ingen MCP-servere tilgjengelige for din organisasjon.',
  'servers.empty.userSubtitle': 'Du har ikke tilgang til MCP-er ennå. Be administratoren din om å gi deg tilgang.',

  'servers.sort.activated': 'Aktivert først',
  'servers.sort.nameAsc': 'Navn A–Z',
  'servers.sort.nameDesc': 'Navn Z–A',
  'servers.sort.newest': 'Nyeste først',
  'servers.sort.oldest': 'Eldste først',
  'servers.filter.allApps': 'Alle applikasjoner',
  'servers.filter.selected': 'valgt',

  'serverCard.activateButton': 'Aktiver MCP',
  'serverCard.instantAddButton': 'Legg til umiddelbart',
  'serverCard.slotLimitTooltip': 'Plangrense nådd (oppgrader planen din)',

  'serverDetail.backButton': 'Alle servere',
  'serverDetail.notFound.title': 'MCP-server ikke funnet',
  'serverDetail.tools.defaultTag': 'Annet',
  'serverDetail.header.activateMcp': 'Aktiver MCP',
  'serverDetail.header.requestAccess': 'Be om tilgang',
  'serverDetail.blocked': 'Denne MCP-en er midlertidig deaktivert til {until}.',
  'serverDetail.tabs.about': 'Om',
  'serverDetail.tabs.connect': 'Koble til',
  'serverDetail.tabs.tools': 'Verktøy ({count})',
  'serverDetail.tabs.skills': 'Ferdigheter ({count})',
  'serverDetail.tabs.users': 'Brukere',
  'serverDetail.tabs.logs': 'Logger',
  'serverDetail.about.empty': 'Ingen detaljert beskrivelse tilgjengelig.',
  'serverDetail.skills.empty': 'Ingen ferdigheter tilgjengelige.',
  'serverDetail.copySkill': 'Kopier ferdighet',
  'serverDetail.connect.noAccess.title': 'Ingen tilgang',
  'serverDetail.connect.noAccess.body': 'Be om tilgang først for å se tilkoblingsinstruksjoner.',
  'serverDetail.connect.inactiveAlert': 'Autentisering fungerer bare når denne MCP-en er aktivert for din organisasjon.',
  'serverDetail.connect.step.addServer': 'Legg til MCP-server',
  'serverDetail.connect.step.authenticate': 'Autentiser',
  'serverDetail.connect.step.createProject': 'Opprett prosjekt',
  'serverDetail.connect.step.addCustomInstructions': 'Legg til egendefinerte instruksjoner',
  'serverDetail.connect.step.runCommand': 'Kjør følgende kommando i terminalen:',
  'serverDetail.connect.step.addSkills': 'Legg til ferdigheter',
  'serverDetail.connect.claude.desktop.step1.hint': 'Åpne Claude Desktop eller claude.ai og gå til Settings → Connectors → Add custom connector. Skriv inn URL-en nedenfor og klikk Add.',
  'serverDetail.connect.claude.desktop.step2.hint': 'Etter at du har lagt til, vises MCP-serveren i tilkoblingslisten din. Klikk på den for å autentisere med legitimasjonen din.',
  'serverDetail.connect.claude.desktop.step3.hint': 'Opprett et nytt prosjekt via venstremenyen i Claude og legg til MCP-serveren som en tilkobling i prosjektinnstillingene.',
  'serverDetail.connect.claude.desktop.step4.hint': 'Legg til instruksjonene nedenfor i prosjektinstruksjonsfeltet for best resultat.',
  'serverDetail.connect.claude.code.step1.altHint': 'Eller legg til i',
  'serverDetail.connect.claude.code.step2.hint': 'Ved første gangs bruk åpner Claude Code automatisk et nettleservindu for innlogging. Etter autentisering er MCP-serveren klar til bruk.',
  'serverDetail.connect.claude.code.step3.title': 'Prosjektinstruksjoner (CLAUDE.md)',
  'serverDetail.connect.claude.code.step3.hint': 'Opprett en CLAUDE.md-fil i prosjektroten med innholdet nedenfor.',
  'serverDetail.connect.claude.code.step4.hint': 'Kopier ferdighetene nedenfor til .claude/skills/-katalogen i prosjektet ditt.',
  'serverDetail.connect.copilot.app.step1.hint': 'Åpne Microsoft 365 Copilot Studio og naviger til agenten din. Gå til Actions → Add action → MCP Server. Skriv inn URL-en nedenfor.',
  'serverDetail.connect.copilot.app.step2.hint': 'Etter at MCP-serveren er lagt til, vil Copilot be deg om å logge inn. Logg inn med dine legitimasjoner for å autorisere tilgang.',
  'serverDetail.connect.copilot.app.step3.hint': 'Legg til innholdet nedenfor som instruksjoner til Copilot-agenten din for å styre bruken av denne MCP-serveren.',
  'serverDetail.connect.copilot.app.step4.hint': 'Legg til følgende instruksjoner i Copilot-agenten din for best resultat.',
  'serverDetail.connect.copilot.vscode.step1.hint': 'Åpne VS Code og gå til Settings (Ctrl+,) → søk "mcp". Klikk "Edit in settings.json" og legg til konfigurasjonen nedenfor under "github.copilot.chat.mcp.servers":',
  'serverDetail.connect.copilot.vscode.step2.hint': 'Ved første bruk åpner Copilot automatisk et nettleservindu for innlogging. Logg inn med dine legitimasjoner.',
  'serverDetail.connect.copilot.vscode.step3.hint': 'Opprett en .github/copilot-instructions.md fil i prosjektets rotmappe med innholdet nedenfor.',
  'serverDetail.connect.copilot.vscode.step4.hint': 'Legg til følgende instruksjoner i .github/copilot-instructions.md-filen for best resultat.',
  'serverDetail.connect.chatgpt.step1.hint': 'Åpne ChatGPT og gå til Settings → Connectors → Advanced. Skriv inn URL-en nedenfor og klikk Save.',
  'serverDetail.connect.chatgpt.step2.hint': 'Etter opprettelsen blir du automatisk omdirigert for å autentisere. Logg inn med legitimasjonen din.',
  'serverDetail.connect.chatgpt.step3.hint': 'Opprett et nytt prosjekt i ChatGPT-sidefeltet og legg til MCP-serveren som en tilkobling.',
  'serverDetail.connect.chatgpt.step4.hint': 'Legg til instruksjonene nedenfor i prosjektinstruksjonene for best resultat.',
  'serverDetail.connect.gemini.app.step1.title': 'Opprett Gem',
  'serverDetail.connect.gemini.app.step1.hint': 'Åpne Gemini og gå til Gem manager → New Gem. Gi den et navn og en beskrivelse.',
  'serverDetail.connect.gemini.app.step2.title': 'Gem-instruksjoner',
  'serverDetail.connect.gemini.app.step2.hint': 'Lim inn instruksjonene nedenfor i instruksjonsfeltet til Gem-en din.',
  'serverDetail.connect.gemini.app.step3.hint': 'Legg til instruksjonene nedenfor i instruksjonsfeltet til Gem-en din.',
  'serverDetail.connect.gemini.cli.step1.altHint': 'Eller legg til i .gemini/settings.json:',
  'serverDetail.connect.gemini.cli.step2.hint': 'Ved første gangs bruk åpner Gemini CLI automatisk et nettleservindu for innlogging. Etter autentisering er MCP-serveren klar til bruk.',
  'serverDetail.connect.gemini.cli.step3.title': 'Prosjektinstruksjoner (GEMINI.md)',
  'serverDetail.connect.gemini.cli.step3.hint': 'Opprett en GEMINI.md-fil i prosjektroten med innholdet nedenfor.',
  'serverDetail.connect.gemini.cli.step4.hint': 'Kopier ferdighetene nedenfor til .gemini/skills/-katalogen i prosjektet ditt.',
  'serverDetail.environment': 'Miljø',
  'serverDetail.environments': 'Miljøer',
  'serverDetail.selectEnvironment': 'Velg miljø',

  'serverDetail.connected': 'Tilkoblet',

  'serverDetail.remove': 'Fjern MCP',
  'serverDetail.removing': 'Fjerner...',
  'serverDetail.removeConfirm':
    'Er du sikker på at du vil fjerne denne MCP-en? All brukertilgang og chatinstallasjoner fjernes.',

  'myRequests.page.title': 'Mine forespørsler',
  'myRequests.page.subtitle': 'Oversikt over dine forespørsler.',
  'myRequests.empty.title': 'Ingen forespørsler',
  'myRequests.empty.subtitle': 'Du har ikke sendt inn noen forespørsler ennå.',
  'myRequests.platformRequests.sectionTitle': 'Plattformforespørsler',
  'myRequests.accessRequests.sectionTitle': 'Tilgangsforespørsler',
  'myRequests.platformRequests.col.tier': 'Nivå',
  'myRequests.col.status': 'Status',
  'myRequests.col.date': 'Dato',
  'myRequests.col.note': 'Merknad',
  'myRequests.col.actions': '',
  'myRequests.cancel': 'Avbryt',
  'myRequests.cancelConfirm': 'Er du sikker på at du vil avbryte denne forespørselen?',
  'myRequests.accessRequests.col.server': 'MCP-server',
  'myRequests.accessRequests.col.type': 'Type',
  'myRequests.requestType.organization': 'Organisasjon',
  'myRequests.requestType.user': 'Bruker',

  'seats.page.title': 'Brukeradministrasjon',
  'seats.page.subtitle': 'plasser i bruk',
  'seats.addButton': 'Tildel plass',
  'seats.col.email': 'E-post',
  'seats.col.assignedBy': 'Tildelt av',
  'seats.col.chat': 'Chat',
  'seats.chat.disable': 'Deaktiver chat',
  'seats.chat.enable': 'Aktiver chat',
  'seats.deleteTooltip': 'Fjern plass',
  'seats.deleteConfirm': 'Er du sikker på at du vil fjerne denne plassen?',
  'seats.table.empty': 'Ingen plasser tildelt ennå.',
  'seats.accessDenied.title': 'Ingen tilgang',
  'seats.accessDenied.body': 'Brukeradministrasjon er kun tilgjengelig for administratorer.',
  'seats.assignDialog.title': 'Tildel plass',
  'seats.assignDialog.searchLabel': 'Søk bruker',
  'seats.assignDialog.searchPlaceholder': 'Navn eller e-postadresse',
  'seats.assignDialog.searchMinChars': 'Skriv minst 2 tegn for å søke',
  'seats.assignDialog.noUsers': 'Ingen brukere funnet',
  'seats.assignDialog.assignButton': 'Tildel',
  'seats.assignDialog.assigningButton': 'Tildeler...',

  'usage.page.title': 'Forbruk',
  'usage.page.subtitle': 'Gjeldende måned — kostnader og forbruk for din organisasjon.',
  'usage.page.periodBanner': 'Denne måneden så langt · {period}',
  'usage.historyButton': 'Tidligere måneder',
  'usage.limitsButton': 'Grenser',
  'usage.dailyTable.title': 'Daglig oversikt',
  'usage.col.mcp': 'MCP',
  'usage.col.workflow': 'Arbeidsflyter',
  'usage.col.chat': 'Chat',
  'usage.col.total': 'Totalt',
  'usage.dailyTable.empty': 'Ingen data denne måneden.',
  'usage.costSummary.title': 'Månedlige kostnader',
  'usage.costSummary.subtitle': 'Hva som faktureres denne måneden',
  'usage.costSummary.fixedCosts': 'Faste kostnader',
  'usage.costSummary.platformCosts': 'MCP-bruk',
  'usage.costSummary.workflowCosts': 'Arbeidsflyt-kjøringer',
  'usage.costSummary.executionsSuffix': '{n} kjøringer',
  'usage.costSummary.chatCosts': 'AI-chatbruk',
  'usage.fixedCosts.title': 'Månedlige faste kostnader',
  'usage.fixedCosts.seats': 'Plasser: {count} × {price}',
  'usage.fixedCosts.mcps': 'MCP-er: {count} × {price}',
  'usage.fixedCosts.workflows': 'Arbeidsflyter: {count} × {price}',
  'usage.fixedCosts.subtotal': 'Subtotal',
  'usage.percentOfLimit': '{pct}% av grense ({budget})',
  'usage.breakdown.title': 'Kostnader per kilde',
  'usage.breakdown.mcpTitle': 'MCP-servere',
  'usage.breakdown.workflowTitle': 'Arbeidsflyter',
  'usage.breakdown.showMore': 'Vis {count} til',
  'usage.breakdown.showLess': 'Vis mindre',
  'usage.breakdown.empty': 'Ingen kostnader',
  'usage.empty': 'Ingen forbruksdata ennå. Bruk MCP-servere, arbeidsflyter eller chat for å generere forbruk.',
  'usage.accessDenied.title': 'Ingen tilgang',
  'usage.accessDenied.body': 'Forbruk er kun tilgjengelig for administratorer.',
  'usage.budgetDialog.title': 'Sett kostnadsgrenser',
  'usage.budgetDialog.platformLimit': 'MCP-grense (EUR/måned)',
  'usage.budgetDialog.workflowLimit': 'Arbeidsflyt-grense (EUR/måned)',
  'usage.budgetDialog.aiHourlyLimit': 'AI-timegrense for arbeidsflyter (EUR/time)',
  'usage.budgetDialog.aiHourlyLimitHint':
    'Hard stopp på automatiske AI-kall i arbeidsflyter. Ved overskridelse stopper arbeidsflyten.',
  'usage.budgetDialog.aiHourlyLimitCeilingHint':
    'Plattformtak: {ceiling}/time. Kontakt plattform-admin for å heve det.',
  'usage.budgetDialog.noLimit': 'Ingen grense',
  'usage.budgetDialog.hint': 'Sett til 0 eller la stå tomt for ingen grense.',
  'usage.historyDialog.title': 'Tidligere måneder',
  'usage.historyDialog.empty': 'Ingen historiske data tilgjengelig.',
  'usage.historyDialog.col.month': 'Måned',
  'usage.historyDialog.col.seats': 'Plasser',
  'usage.historyDialog.col.mcps': 'MCP-er',
  'usage.historyDialog.col.fixedCosts': 'Faste kostnader',
  'usage.historyDialog.col.platform': 'MCP',
  'usage.historyDialog.col.workflows': 'Arbeidsflyter',
  'usage.historyDialog.col.chat': 'Chat',
  'usage.historyDialog.col.total': 'Totalt',

  // AI quota widget
  'usage.aiQuota.title': 'AI-timegrense for arbeidsflyter',
  'usage.aiQuota.subtitle': 'Hard stopp på automatiske AI-kall i arbeidsflyter',
  'usage.aiQuota.spent': 'Brukt denne timen',
  'usage.aiQuota.quota': 'Timebegrensning',
  'usage.aiQuota.unmetered': 'Ubegrenset — ingen timebegrensning aktiv for denne organisasjonen.',
  'usage.aiQuota.unavailable': 'Direkte AI-budsjett er midlertidig utilgjengelig.',
  'usage.aiQuota.helper': 'Reduseres gradvis når eldre kall faller utenfor 1-times vinduet.',
  'usage.aiQuota.percentOfQuota': '{pct}% av timebegrensning',
  'usage.breakdown.workflowLabelPrefix': 'Arbeidsflyt:',
  'usage.breakdown.subtitle': 'Variable kostnader per kilde',

  'requestAccess.title': 'Aktiver MCP for min organisasjon',
  'requestAccess.success': 'Forespørselen din for {serverName} er sendt. En administrator vil vurdere den.',
  'requestAccess.description': 'Denne MCP-en er ikke aktivert for din organisasjon ennå. Angi miljøet du vil aktivere MCP-en for.',
  'requestAccess.envUrlLabel': 'Miljø-URL',
  'requestAccess.envUrlPlaceholder': 'https://api.mittmiljo.no',
  'requestAccess.envUrlHelper': 'API-URL-en til miljøet du vil ha tilgang til',
  'requestAccess.messageLabel': 'Melding (valgfritt)',
  'requestAccess.messagePlaceholder': 'Hvorfor trenger du tilgang?',
  'requestAccess.urlError': 'Skriv inn en gyldig HTTPS-URL (f.eks. https://api.example.no)',
  'requestAccess.environmentLabel': 'Miljø',
  'requestAccess.submitButton': 'Send forespørsel',
  'requestAccess.submittingButton': 'Sender...',

  'toolsTable.col.name': 'Navn',
  'toolsTable.col.type': 'Type',
  'toolsTable.col.required': 'Påkrevd',
  'toolsTable.col.description': 'Beskrivelse',
  'toolsTable.empty': 'Ingen verktøy tilgjengelige.',

  'logsTab.title': 'Nylige logger',
  'logsTab.empty': 'Ingen logger tilgjengelig for denne serveren.',
  'logsTab.col.tool': 'Verktøy',
  'logsTab.col.user': 'Bruker',
  'logsTab.col.responseTime': 'Responstid',
  'logsTab.status.success': 'Suksess',
  'logsTab.status.error': 'Feil',

  'usersTab.title': 'Brukeradministrasjon',
  'usersTab.empty': "Legg til en bruker i 'Brukere' for å gi en bruker tilgang til denne MCP-en.",
  'usersTab.col.user': 'Bruker',
  'usersTab.col.access': 'Tilgang',
  'usersTab.revokeButton': 'Tilbakekall',
  'usersTab.activateButton': 'Aktiver',

  'upgradeBanner.text': 'Oppgrader til team for flere plasser og høyere grenser, eller til enterprise for ubegrensede plasser, ingen grenser og våre egne EU-hostede modeller.',
  'upgradeBanner.textTeam': 'Trenger du flere plasser eller MCP-er? Oppgrader til enterprise for ubegrenset tilgang, EU-hostede chat-modeller og alt {title} har å tilby.',
  'upgradeBanner.pending': 'Forespørsel behandles',
  'upgradeBanner.upgradeTeamButton': 'Oppgrader til team',
  'upgradeBanner.upgradeEnterpriseButton': 'Aktiver enterprise',

  'pricing.page.title': 'Velg en plan',
  'pricing.page.subtitle': 'Aktiver riktig plan for din organisasjon for å komme i gang med MCP Hub.',
  'pricing.adminOnly': 'Kun administratorer kan be om en plan.',
  'pricing.pendingRequest': 'En forespørsel behandles allerede. Du får beskjed når den er vurdert.',
  'pricing.currentPlan.chip': 'Nåværende plan',
  'pricing.button.current': 'Nåværende plan',
  'pricing.button.requesting': 'Ber om...',
  'pricing.button.request': 'Be om',
  'pricing.snackbar.submitted': 'Forespørsel sendt — du får beskjed når den er behandlet.',
  'pricing.tier.free.label': 'Free',
  'pricing.tier.free.tagline': 'Bli kjent med MCP-plattformen',
  'pricing.tier.free.feature.mcps': '1 MCP aktiv',
  'pricing.tier.free.feature.seats': '1 plass (kun deg selv)',
  'pricing.tier.free.feature.calls': 'Maks 100 kall per dag',
  'pricing.tier.team.label': 'Team',
  'pricing.tier.team.tagline': 'For team',
  'pricing.tier.team.feature.mcps': '3 MCP-er aktive',
  'pricing.tier.team.feature.seats': '6 plasser',
  'pricing.tier.team.feature.calls': 'Maks 1 000 kall per dag',
  'pricing.tier.enterprise.label': 'Enterprise',
  'pricing.tier.enterprise.tagline': 'Maksimal fleksibilitet for store organisasjoner',
  'pricing.tier.enterprise.feature.mcps': 'Ubegrensede MCP-er',
  'pricing.tier.enterprise.feature.seats': 'Ubegrensede plasser',
  'pricing.tier.enterprise.feature.calls': 'Ubegrensede kall',
  'pricing.tier.enterprise.feature.chat': 'Europeisk hostede modeller',
  'pricing.tier.enterprise.feature.governance': 'Guardrails og AI-styring',

  'pending.title': 'Forespørsel behandles',
  'pending.body': 'Forespørselen din er mottatt. Vi kontakter deg så snart som mulig for å aktivere tilgangen din.',

  'registration.welcome': 'Velkommen til {title}',
  'registration.heading': 'Hvordan vil du bruke {title}?',
  'registration.subheading': 'Velg alternativet som passer best for din situasjon. Du kan alltid oppgradere senere.',
  'registration.tier.free.tagline': 'Utforsk mulighetene',
  'registration.tier.team.tagline': 'Implementer med et team',
  'registration.tier.enterprise.tagline': 'Fullt operasjonelt',
  'registration.messagePlaceholder': 'Valgfritt: Fortell oss om ditt bruksområde og forventninger...',
  'registration.submitButton': 'Send forespørsel',
  'registration.submitButtonFree': 'Test nå',

  'authGuard.accessDenied.title': 'Ingen tilgang',
  'authGuard.accessDenied.body': 'Du har ikke tilgang til MCP Hub. Kontakt administratoren din for å få en plass.',
  'authGuard.tryAgain': 'Prøv igjen',
  'authGuard.joinPrompt.title': 'Bli medlem av {org}',
  'authGuard.joinPrompt.body': 'En organisasjon for e-postdomenet ditt finnes allerede. Be om tilgang, så gjennomgår en administrator forespørselen.',
  'authGuard.joinPrompt.requestAccess': 'Be om tilgang',
  'authGuard.joinPrompt.cancel': 'Ikke nå',
  'authGuard.orgSignupPrompt.title': 'Sett opp organisasjonen din',
  'authGuard.orgSignupPrompt.body': 'Det finnes ingen organisasjon for kontoen din ennå. Gi organisasjonen et navn for å fullføre arbeidsområdet ditt.',
  'authGuard.orgSignupPrompt.submit': 'Opprett organisasjon',
  'authGuard.orgSignupPrompt.cancel': 'Logg ut',

  'errorBoundary.title': 'Noe gikk galt',
  'errorBoundary.body': 'Prøv å laste siden på nytt. Kontakt support hvis problemet vedvarer.',
  'errorBoundary.reloadButton': 'Last siden på nytt',

  'accessStatus.full_access': 'Tilkoblet',
  'accessStatus.org_linked_no_user': 'Ingen tilgang',
  'accessStatus.not_linked': 'Ikke aktivert',
  'accessStatus.request_pending': 'Forespørsel sendt',
  'accessStatus.instant_available': 'Umiddelbart tilgjengelig',
  'accessStatus.active': 'Aktiv',

  'requestStatus.pending': 'Under behandling',
  'requestStatus.approved': 'Godkjent',
  'requestStatus.denied': 'Avslått',
  'requestStatus.cancelled': 'Avbrutt',

  'tierLabel.free': 'Free',
  'tierLabel.team': 'Team',
  'tierLabel.enterprise': 'Enterprise',

  'plan.page.title': 'Min plan',
  'plan.page.subtitle': 'Oversikt over din nåværende plan og bruk.',
  'plan.accessDenied.title': 'Ingen tilgang',
  'plan.accessDenied.body': 'Planbehandling er bare tilgjengelig for administratorer.',
  'plan.activateCta.title': 'Aktiver en plan nå',
  'plan.activateCta.body': 'Du har ingen aktiv plattform ennå. Aktiver en plan for å bruke MCPer.',
  'plan.activateCta.button': 'Aktiver plan',
  'plan.organization': 'Organisasjon',
  'plan.stat.mcps': 'MCPer aktive',
  'plan.stat.seats': 'Seter i bruk',
  'plan.changePlanButton': 'Endre plan',
  'plan.tier.none': 'Ingen plan',
  'plan.tier.free': 'Free',
  'plan.tier.team': 'Team',
  'plan.tier.enterprise': 'Enterprise',

  // Tier features (constants)
  'tier.free.label': 'Test oppsett',
  'tier.free.feature.seats': '1 plass',
  'tier.free.feature.mcps': '1 MCP aktiv',
  'tier.free.feature.requests': 'Begrensede daglige forespørsler',
  'tier.team.label': 'Pilotimplementering',
  'tier.team.feature.seats': '6 plasser',
  'tier.team.feature.mcps': '3 MCP-er aktive',
  'tier.team.feature.requests': 'Flere forespørsler per dag',
  'tier.enterprise.label': 'Produksjon',
  'tier.enterprise.feature.seats': 'Ubegrensede plasser',
  'tier.enterprise.feature.mcps': 'Alle MCP-er',
  'tier.enterprise.feature.chat': 'Chat inkludert',

  'workflow.title': 'Arbeidsflyter',
  'workflow.subtitle': 'Automatiserte MCP-verktøykjeder for organisasjonen din',
  'workflow.configure': 'Konfigurer',
  'workflow.instantAdd': 'Legg til direkte',
  'workflow.requestAccess': 'Be om tilgang',
  'workflow.awaitingApproval': 'Venter på godkjenning',
  'workflow.empty': 'Ingen arbeidsflyter tilgjengelig ennå',
  'workflow.upgradeRequired': 'Oppgrader planen din for å bruke arbeidsflyter',
  'workflow.filter.allTriggers': 'Alle triggere',
  'workflow.trigger.manual': 'Manuell',
  'workflow.trigger.cron': 'Planlagt',
  'workflow.trigger.mcp': 'MCP',
  'workflow.requestDialog.description': 'Angi MCP-serverkonfigurasjon for hver server som brukes i denne arbeidsflyten.',
  'workflow.requestDialog.mcpConfig': 'MCP-serverkonfigurasjon',
  'workflow.requestDialog.variables': 'Variabler',
  'workflow.requestDialog.variablesHelper': 'Verdier organisasjonen din oppgir for variablene denne arbeidsflyten refererer til. La stå tomt for å fylle inn senere via lenke-konfigurasjonen.',
  'workflow.requestDialog.seat': 'Bruker',
  'workflow.requestDialog.environment': 'Milj\u00f8',
  'workflow.requestDialog.selectEnvironment': 'Velg et milj\u00f8',
  'workflow.requestDialog.baseUrl': 'M\u00e5l-URL',
  'workflow.requestDialog.message': 'Melding (valgfritt)',
  'workflow.requestDialog.messagePlaceholder': 'Ekstra kontekst for administratoren...',
  'workflow.requestDialog.cancel': 'Avbryt',
  'workflow.requestDialog.submit': 'Send forespørsel',
  'workflow.requestDialog.attachmentLabel': 'Vedlegg',
  'workflow.requestDialog.attachmentChoose': 'Velg fil',
  'workflow.requestDialog.attachmentNone': 'Ingen fil valgt',
  'workflow.requestDialog.attachmentRequired': 'Denne arbeidsflyten krever et vedlegg.',
  'workflow.requestDialog.attachmentHelp': 'Denne filen er datakilden for arbeidsflyten. Maks 10 MB.',
  'workflow.tabs.flow': 'Flyt',
  'workflow.tabs.connect': 'Koble til',
  'workflow.connect.urlLabel': 'MCP-server-URL',
  'workflow.connect.urlHelp': 'Legg til denne URL-en som en MCP-server i Claude Desktop. Autentisering går via SecureAccess-pålogging.',
  'workflow.connect.heroEyebrow': 'Koble til via MCP',
  'workflow.connect.heroTitle': 'Bruk %{workflow} fra din AI-assistent',
  // eslint-disable-next-line max-len
  'workflow.connect.heroBody': 'Legg til URL-en nedenfor som MCP-server i Claude. Logg på én gang med din SecureAccess-konto; arbeidsflyten dukker så opp som et verktøy i hver samtale.',
  'workflow.connect.step.add': 'Legg til som MCP-server',
  'workflow.connect.step.addHint': 'Rediger Claude Desktop-konfigurasjonen og start Claude Desktop på nytt.',
  'workflow.connect.inactiveAlert': 'Autentisering fungerer bare når denne arbeidsflyten er aktivert for din organisasjon.',
  'workflow.connect.step.login': 'Logg på SecureAccess',
  // eslint-disable-next-line max-len
  'workflow.connect.step.loginHint': 'Første gang åpner Claude et nettleservindu for SecureAccess OAuth-flyten. Godkjenn og tilkoblingen er bundet til din konto.',
  'workflow.connect.step.prompt': 'Prøv det',
  // eslint-disable-next-line max-len
  'workflow.connect.step.promptHint': 'I en ny chat dukker arbeidsflyten opp som et verktøy. Be Claude om å bruke den med en naturlig instruksjon.',
  'workflow.connect.desktop.step1Title': 'Legg til i claude_desktop_config.json',
  // eslint-disable-next-line max-len
  'workflow.connect.desktop.step1Hint': 'Åpne Claude Desktop-innstillinger → Developer → Edit config, lim inn snippeten under, lagre og start Claude Desktop på nytt.',
  'workflow.connect.code.step1Title': 'Kjør claude mcp add',
  // eslint-disable-next-line max-len
  'workflow.connect.code.step1Hint': 'Kjør kommandoen under i en terminal. Claude Code registrerer arbeidsflyten for det gjeldende prosjektet.',
  'workflow.connect.web.step1Title': 'Legg til en tilpasset connector på claude.ai',
  // eslint-disable-next-line max-len
  'workflow.connect.web.step1Hint': 'Åpne Connectors-siden i dine Claude.ai-innstillinger, velg Add custom connector og lim inn URL-en.',
  'workflow.connect.noAccess.title': 'Ingen tilgang ennå',
  'workflow.connect.noAccess.body': 'Be om tilgang til denne arbeidsflyten først.',
  'workflow.loadError': 'Kunne ikke laste arbeidsflyter',
  'workflow.actionError': 'Handling mislyktes. Prøv igjen.',
  'workflow.ai.button': 'Generer med AI',
  'workflow.ai.title': 'AI-arbeidsflytgenerator',
  'workflow.ai.intro':
    'Beskriv prosessen arbeidsflyten skal utfore. Forklar hvordan den skal startes, stegene underveis og det forventede resultatet. AI-en var analyserer beskrivelsen; nar den har nok informasjon kan du sende arbeidsflyten til godkjenning.',
  'workflow.ai.guide.title': 'Slik bygges en arbeidsflyt',
  'workflow.ai.guide.subtitle': 'Klikk for en kort gjennomgang av byggesteinene.',
  'workflow.ai.guide.triggerTitle': 'Utloser',
  'workflow.ai.guide.triggerBody':
    'Hver arbeidsflyt starter med en utloser — en manuell handling, en plan (f.eks. hver hverdag kl. 9:00) eller en innkommende webhook fra et annet system.',
  'workflow.ai.guide.toolTitle': 'Koble til et system',
  'workflow.ai.guide.toolBody':
    'Verktoy-steg henter eller endrer data i et tilkoblet MCP-system (Topdesk, Slack, saksbehandlingssystemet, ...). Nevn systemet og hva det skal gjore.',
  'workflow.ai.guide.aiTitle': 'La AI tenke',
  'workflow.ai.guide.aiBody':
    'AI-steg kan oppsummere, oversette, klassifisere eller hente ut bestemte felter fra tidligere utdata. Vær konkret om input og onsket resultat.',
  'workflow.ai.guide.logicTitle': 'Logikk & lokker',
  'workflow.ai.guide.logicBody':
    'Bruk betingelser ("bare nar status = apen") og lokker ("for hver sak, ...") for a styre hvordan arbeidsflyten gar gjennom dataene.',
  'workflow.ai.guide.outputTitle': 'Sluttdestinasjon',
  'workflow.ai.guide.outputBody':
    'Fortell administratoren hvor resultatet skal: en Slack-kanal, en e-post, en varsling, en ny sak eller en visualisering i dashbordet.',
  'workflow.ai.guide.exampleTitle': 'Eksempel',
  'workflow.ai.guide.exampleBody':
    '"Hent apne elementer fra system A, la AI oppsummere dem og legg resultatet i system B."',
  'workflow.ai.descriptionLabel': 'Beskriv arbeidsflyten',
  'workflow.ai.descriptionPlaceholder':
    'Hver hverdag klokken 9:00 hentes apne Topdesk-saker, oppsummeres med en LLM og legges ut i #service-desk pa Slack.',
  'workflow.ai.submit': 'Fortsett',
  'workflow.ai.analyzing': 'Analyserer beskrivelsen…',
  'workflow.ai.needsMoreInfo': 'Jeg trenger litt mer informasjon',
  'workflow.ai.answerLabel': 'Legg til detaljene som mangler',
  'workflow.ai.answerPlaceholder': 'Oppgi den manglende informasjonen…',
  'workflow.ai.summaryTitle': 'Dette skal bygges',
  'workflow.ai.summaryHintRequest':
    'En administrator gjennomgar beskrivelsen og bygger arbeidsflyten etter godkjenning.',
  'workflow.ai.requestButton': 'Send forespørsel',
  'workflow.ai.edit': 'Juster beskrivelsen',
  'workflow.ai.requesting': 'Sender forespørselen…',
  'workflow.ai.requestedTitle': 'Forespørsel sendt',
  'workflow.ai.requestedMessage':
    'En administrator er varslet. Du hører fra dem nar arbeidsflyten er bygget.',
  'workflow.ai.close': 'Lukk',
  'workflow.ai.errorTitle': 'Noe gikk galt',
  'workflow.ai.errorBody': 'Assistenten kunne ikke behandle forespørselen.',
  'workflow.ai.retry': 'Prov igjen',
  'myRequests.aiRequests.sectionTitle': 'AI-arbeidsflyt-foresporsler',
  'myRequests.aiRequests.col.prompt': 'Beskrivelse',
  'workflow.nodeDetail.title': 'Node-konfigurasjon',
  'workflow.nodeDetail.triggerType': 'Trigger-type',
  'workflow.nodeDetail.cronExpression': 'Tidsplan',
  'workflow.nodeDetail.webhookPath': 'Webhook-sti',
  'workflow.nodeDetail.server': 'MCP Server',
  'workflow.nodeDetail.tool': 'Verktøy',
  'workflow.nodeDetail.parameters': 'Parametere',
  'workflow.nodeDetail.expression': 'Uttrykk',
  'workflow.nodeDetail.arrayExpression': 'Array-uttrykk',
  'workflow.nodeDetail.itemVariable': 'Element-variabel',
  'workflow.nodeDetail.strategy': 'Strategi',
  'workflow.nodeDetail.mappings': 'Felttilordninger',
  'workflow.nodeDetail.triggerButton': 'Start arbeidsflyt',
  'workflow.nodeDetail.triggerSuccess': 'Arbeidsflyt startet',
  'workflow.nodeDetail.triggerError': 'Kunne ikke starte arbeidsflyt',
  'workflow.nodeDetail.type': 'Type',

  'workflow.backButton': 'Tilbake til arbeidsflyter',
  'workflow.remove': 'Fjern arbeidsflyt',
  'workflow.removing': 'Fjerner...',
  'workflow.removeConfirm': 'Er du sikker på at du vil fjerne denne arbeidsflyten? All tilgang blir tilbakekalt og alle kjøre-registreringer (kjøringer og forbrukslogger) blir permanent slettet.',
  'workflow.trigger': 'Utfør',
  'workflow.triggerSuccess': 'Arbeidsflyt startet',
  'workflow.variables.missingTitle': 'Variabler mangler',
  'workflow.variables.missingBody': 'Denne arbeidsflyten refererer til variabler som organisasjonen din ikke har en verdi for. Be en administrator om å fylle dem inn via lenke-konfigurasjonen før neste kjøring.',
  'workflow.tabs.about': 'Om',
  'workflow.tabs.tools': 'Verktøy',
  'workflow.badge.mcp': 'MCP',
  'workflow.badge.ai': 'AI',
  'workflow.badge.mcpTooltip': 'Eksponert som MCP-verktøy for AI-klienter',
  'workflow.badge.aiTooltip': 'Inneholder et AI-steg',
  'workflow.tabs.diagram': 'Diagram',
  'workflow.tabs.executions': 'Utførelser',
  'workflow.about.empty': 'Ingen beskrivelse tilgjengelig',
  'workflow.executions.empty': 'Ingen utførelser ennå',
  'workflow.executions.status': 'Status',
  'workflow.executions.trigger': 'Trigger',
  'workflow.executions.startedBy': 'Startet av',
  'workflow.executions.started': 'Startet',
  'workflow.executions.duration': 'Varighet',
  'workflow.executionStatus.pending': 'Ventende',
  'workflow.executionStatus.running': 'Kjører',
  'workflow.executionStatus.completed': 'Fullført',
  'workflow.executionStatus.failed': 'Mislyktes',
  'workflow.triggerType.manual': 'Manuell',
  'workflow.triggerType.cron': 'Planlagt',
  'workflow.triggerType.webhook': 'Webhook',
  'workflow.stats.nodes': '{count} noder',
  'workflow.stats.trigger': 'Trigger: {type}',
  'workflow.notFound.title': 'Arbeidsflyt ikke funnet',

  'workflow.tabs.users': 'Brukere',

  'workflow.tabs.webhook': 'Webhook',
  'workflow.webhook.title': 'Webhook-integrasjon',
  'workflow.webhook.description': 'Utløs denne arbeidsflyten fra et eksternt system ved å sende en POST-forespørsel til URL-en nedenfor.',
  'workflow.webhook.url': 'Webhook URL',
  'workflow.webhook.auth': 'Autentisering',
  'workflow.webhook.authDescription': 'Inkluder et gyldig Bearer-token i Authorization-headeren.',
  'workflow.webhook.parameters': 'Parametere',
  'workflow.webhook.parametersDescription': 'Send parametere som JSON i forespørselskroppen under "trigger_input"-nøkkelen.',
  'workflow.webhook.name': 'Navn',
  'workflow.webhook.type': 'Type',
  'workflow.webhook.required': 'Påkrevd',
  'workflow.webhook.optional': 'Valgfri',
  'workflow.webhook.descriptionCol': 'Beskrivelse',
  'workflow.webhook.example': 'Eksempelforespørsel',
  'workflow.webhook.noLink': 'Webhook er tilgjengelig etter at arbeidsflyten er koblet til organisasjonen din.',

  'workflow.visualizations.title': 'Visualiseringer',

  'visualization.noData': 'Ingen data tilgjengelig. Kjør arbeidsflyten først.',
  'visualization.accessDenied.title': 'Ingen tilgang',
  'visualization.accessDenied.body': 'Du har ikke tilgang til denne visualiseringen. Kontakt administratoren din.',
  'visualization.notFound.title': 'Ikke funnet',
  'visualization.notFound.body': 'Denne visualiseringen ble ikke funnet.',
};
